import { Box, HStack } from '@chakra-ui/react';
import Button, { ButtonVariants } from '@components/interactive/Button';
import WizardLayout from '@components/layout/layout/WizardLayout';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import { Routes } from '@constants/routes';
import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';
import { CallUsReason } from '@enums/CallUsReason';
import { PlanType } from '@enums/PlanType';
import { formatUserAddress } from '@utils/addresses';
import getPrimaryPlan from '@utils/getPrimaryPlan';
import { useState } from 'react';
import AepBreadCrumbs from '../AepBreadCrumbs';
import CallUsModal from './callUsModal';

const AepZipCode = () => {
  // Resources
  const { authenticatedUser: user } = useAuthenticatedContextProvider();

  const plan = getPrimaryPlan(user);
  const isPdp = plan?.plan_type === PlanType.PDP;
  const nextPath = isPdp ? Routes.aepPrescriptions : Routes.aepProviders;

  // State
  const [showModal, setShowModal] = useState(false);

  return (
    <WizardLayout>
      <AepBreadCrumbs />
      <Header as="h3" textAlign={'center'}>
        Is This Your Current Address?
      </Header>
      {user?.address_line_one ? (
        <Box display="inline-block" textAlign="center">
          {formatUserAddress({ address: user?.profile.primary_address }).map((line) => (
            <Body1 key={line}>{line}</Body1>
          ))}
        </Box>
      ) : (
        <Box textAlign="center">
          <Body1>Is this your current zip code?</Body1>
          <Body1>{user?.zip_code}</Body1>
        </Box>
      )}

      {plan ? (
        <HStack gap={2} align="center" justify="center" w="100%">
          <Button id="aep-address-no" href={`${Routes.aepUpdateAddress}`} variant={ButtonVariants.secondary}>
            No
          </Button>
          <Button href={nextPath} id="aep-address-yes">
            Yes
          </Button>
        </HStack>
      ) : (
        <Button href={`${Routes.accountCallUs}?context=aep`}>Make Appointment</Button>
      )}
      <CallUsModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </WizardLayout>
  );
};

export default AepZipCode;
